/*
 * Ryan O'Dowd
 * 2022-07-22
 * © Copyright 2022 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import globals from '@utils/globals';

const getStyles = ({globalScale, fonts, colors, isDarkMode}) => {
  const jungleLight = require('@assets/img/backgrounds/jungle_light.png');
  const jungleColor = require(`@assets/img/backgrounds/jungle_${colors.themeColor}.png`);

  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 32,
      textAlign: 'left',
    },
    sectionInner: {
      width: '100%',
      maxWidth: globals.maxInnerWidth,
    },
    lightBackground: (xPos, yPos) => { // @TODO: qqq:keep bracket notation
      return {
        color: isDarkMode ? colors.white : colors.primaryExtraDark,
        backgroundImage: `linear-gradient(
          ${isDarkMode ? colors.black : colors.white}cc 0%,
          ${isDarkMode ? colors.black : colors.white}ee 100%
        ), url("${jungleLight}")`,
        backgroundSize: 'cover', // @TODO: would be nice for this to be "cover and zoom" so that the x-pos could be randomized better
        backgroundPosition: `${xPos}% ${yPos}%`,
        backgroundRepeat: 'no-repeat',
      };
    },
    darkBackground: (xPos, yPos) => { // @TODO: qqq:keep bracket notation
      return {
        color: colors.white,
        backgroundImage: `linear-gradient(
          ${colors.primary}d2 0%,
          ${colors.primaryDark}ff 100%
        ), url("${jungleColor}")`,
        backgroundSize: 'cover', // @TODO: would be nice for this to be "cover and zoom" so that the x-pos could be randomized better
        backgroundPosition: `${xPos}% ${yPos}%`,
      };
    },
    webAppContainer: (xPos, yPos) => { // @TODO: this shouldn't be the component responsible for max height and overflow...that should be the inner content below the app header...not sure why scrollview isn't working
      return {
        height: 'calc(100vh - 48px)', // @TODO: is this a good default? // @TODO: don't like hardcoding the header height (fyi, this is the web-app header height...the regular one on landing pages is 56)
        minHeight: 'calc(100vh - 48px)', // @TODO: is this a good default? // @TODO: don't like hardcoding the header height (fyi, this is the web-app header height...the regular one on landing pages is 56)
        maxHeight: 'calc(100vh - 48px)', // @TODO: is this a good default? // @TODO: don't like hardcoding the header height (fyi, this is the web-app header height...the regular one on landing pages is 56)
        overflowY: 'scroll',
        padding: 0,
        color: colors.primaryExtraLight,
        backgroundImage: `linear-gradient(
          ${colors.primary}d2 0%,
          ${colors.primary}d2 100%
        ), url("${jungleColor}")`,
        backgroundSize: 'cover', // @TODO: would be nice for this to be "cover and zoom" so that the x-pos could be randomized better
        backgroundPosition: `${xPos}% ${yPos}%`,
      };
    },
    sectionTitle: {
      fontSize: globalScale * 20,
      marginVertical: globalScale * 12,
      fontFamily: fonts.primaryBold,
    },
    sectionTitleDarkBg: {
      color: isDarkMode ? colors.white : colors.primaryExtraLight,
    },
  };
};

export default getStyles;
